import { Platform } from 'react-native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { createStackNavigator } from '@react-navigation/stack';

export const Stack = Platform.OS === 'web' ? createStackNavigator() : createNativeStackNavigator();
